import {useQuery} from '@tanstack/react-query';
import {useRequiredTenantId} from '@/matic/hooks/useRequiredTenantId';
import {getRelayApi} from '../api/relay-api';
import {relayKeys} from '../query-keys';
import type {RelayPin} from '../types/relay-types';

export function usePins() {
  const tenantId = useRequiredTenantId();
  const api = getRelayApi();

  return useQuery<RelayPin[]>({
    queryKey: relayKeys.pins.list(tenantId),
    queryFn: async () => api.listPins(),
  });
}
